import React from 'react';
import styles from '../../../styles/ReportsDashboard.module.css';

interface StatusBadgeProps {
    status: any
}

const StatusBadge : React.FC<StatusBadgeProps> = ({ status }) => {
    const colorMap: Record<string, string> = {
        Open: '#10b981',
        Pending: '#d97706',
        Closed: '#6b7280',
        Incomplete: '#ef4444',
      };
      return (
        <span
          className={styles.statusBadge}
          style={{ background: colorMap[status] ?? '#6b7280' }}
        >
          {status}
        </span>
      );
}

export default StatusBadge;